import { render, staticRenderFns } from "./CabeceraModalCrearBase.vue?vue&type=template&id=4fe98a1a&"
import script from "./CabeceraModalCrearBase.vue?vue&type=script&lang=ts&"
export * from "./CabeceraModalCrearBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('4fe98a1a', component.options)
    } else {
      api.reload('4fe98a1a', component.options)
    }
    module.hot.accept("./CabeceraModalCrearBase.vue?vue&type=template&id=4fe98a1a&", function () {
      api.rerender('4fe98a1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/reusable/Modal/CabeceraModalCrearBase.vue"
export default component.exports